<template>
    <div v-if="bloco">

        <div class="row">
            <div class="col-sm-12" >
                <button type="button" @click="reset()" class="btn btn-default">
                    CANCELAR
                </button> &nbsp;
                <button type="button" @click="save()" :disabled="!bloco.numero || !bloco.andares" class="btn btn-success">
                    SALVAR BLOCO
                </button>
            </div>
        </div><br/>

        <div class="row">
            <div class="col-sm-3">
                <label for="numero" class="control-label">NÚMERO DO BLOCO</label>
                <input id="numero" type="number" v-model.number="bloco.numero" class="form-control" >
            </div>

            <div class="col-sm-3">
                <label for="andares" class="control-label">QTDE ANDARES</label>
                <input id="andares" type="number" v-model.number="bloco.andares" class="form-control" >
            </div>
        </div><hr/>

        <div class="row" v-if="caixa">
            <div class="col-sm-1">
                <label for="andar" class="control-label">ANDAR</label>
                <input id="andar" type="number" v-model.number="caixa.andar" class="form-control" >
            </div>
            <div class="col-sm-3">
                <label class="control-label">PACPON</label>
                <filtro-pacpon v-model="caixa.pacpon" />
            </div>
            <div class="col-sm-3">
                <label class="control-label">SWITCH</label>
                <filtro-switch v-model="caixa.switche" />
            </div>
            <div class="col-sm-4">
                <button :disabled="!caixa.andar || (!caixa.pacpon && ! caixa.switche)" @click="add()" style="margin-top: 28px" class="btn btn-success" type="button">ADICIONAR</button>
            </div>
        </div>

        <div class="row" v-if="!bloco.caixas.length">
            <div class="col-sm-12">
                <h2 class="text-danger">NENHUMA CAIXA ADICIONADA</h2>
            </div>
        </div>
        <div class="row" v-else>

            <div class="col-sm-12">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width: 60px" class="text-center">ANDAR</th>
                            <th >NOME</th>
                            <th style="width: 100px" class="text-center">AÇÕES</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="c in bloco.caixas" v-bind:key="c.nome">
                        <td class="text-center">
                            {{c.andar}}
                        </td>
                        <td v-if="c.pacpon">{{c.pacpon.nome}}</td>
                        <td v-else-if="c.switche">{{c.switche.nome}}</td>
                        <td v-else></td>
                        <td class="text-center">
                            <button @click="del(c)" class="btn btn-danger btn-xs" type="button">
                                REMOVER
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</template>

<script>
import filtroPacpon from "../../../../components/caixas/filtro-pacpon";
import filtroSwitch from "../../../../components/caixas/filtro-switch";

export default {
    name: "Bloco",
    props: {
        bloco: {
            default: null
        }
    },
    components: {
        filtroPacpon,
        filtroSwitch
    },
    data() {
        return {
            caixa: null
        };
    },
    beforeMount() {
        this.clearCaixa();
    },
    methods: {
        add() {
            this.bloco.caixas.push(Object(this.caixa));
            this.clearCaixa();
        },
        save() {
            this.$emit("save", this.bloco);
        },
        reset() {
            this.$emit("clear");
        },
        del(pac) {
            this.bloco.caixas.forEach(c => {
                if (pac.pacpon && c.pacpon) {
                    if (pac.pacpon._id === c.pacpon._id) {
                        this.bloco.caixas.splice(
                            this.bloco.caixas.indexOf(c),
                            1
                        );
                    }
                }
                console.log("PAC", pac, c);
                if (pac.switche && c.switche) {
                    if (pac.switche._id === c.switche._id) {
                        this.bloco.caixas.splice(
                            this.bloco.caixas.indexOf(c),
                            1
                        );
                    }
                }
            });
        },
        clearCaixa() {
            this.caixa = {
                andar: null,
                pacpon: null,
                switche: null
            };
        }
    }
};
</script>

<style scoped>
</style>
